import { getItem } from '../helpers/object-helper';
import { floatStringFormat } from '../helpers/currency-helper';

const googleMaps = window.google.maps;

const confData = {
    // web api
    api: {
        development: {
            baseUrl: 'http://localhost:3001'
        },
        production: {
            baseUrl: 'https://saetta.amtek.site/sunhubstorageapi'
        }
    },
    // gui data
    gui: {
        loading: {
            label: 'Stiamo elaborando la tua richiesta'
        },
        images: {
            basePath: (process.env.NODE_ENV === 'development') ? '/images' : '/batteria/images' 
        },
        docs: {
            basePath: (process.env.NODE_ENV === 'development') ? '/docs' : '/batteria/docs' 
        },
        map: {
            _k: 'AIzaSyDaJLwsUmFr05RY1WbrzQ-V8suIicSFzIg',
            imageGeneratorUrl: 'https://maps.googleapis.com/maps/api/staticmap',
            address: 'Piazza Duomo, Milano',
            addressMarkerIcon: {
                path: googleMaps.SymbolPath.BACKWARD_CLOSED_ARROW,
                fillColor: '#FF9D2E',
                fillOpacity: 1,
                strokeColor: 'white',
                strokeWeight: 1,
                scale: 4,
                rotation: 30
            },
            mapOptions: {
                zoom: 18,
                mapTypeId: googleMaps.MapTypeId.SATELLITE
            },
            drawingManagerOptions: {},
            markerManagerOptions: {
                markerOptions: {
                    //draggable: true
                    //animation: googleMaps.Animation.DROP
                }
            },
            polygonOptions: {
                strokeWeight: 0,
                fillOpacity: 0.75,
                fillColor: '#FF9D2E',
                editable: true,
                draggable: true
            },
            mapStaticImage: {
                generatorUrl: 'https://maps.googleapis.com/maps/api/staticmap',
                size: '400x400',
                sizeInQuotationsComponent: '463x204',//'331x204',
                scale: 1
            }
        },
        steps: {
            step1: {
                title: 'Indica dov\'è posizionato il tuo impianto fotovoltaico',
                nextValidationFailMessage: 'E\' necessario indicare la posizione dell\'impianto',
                map: {
                    address: 'Piazza Duomo, Milano',
                    mapOptions: {
                        zoom: 18,
                        mapTypeId: googleMaps.MapTypeId.SATELLITE
                    },
                    drawingManagerOptions: {},
                    polygonOptions: {}
                }
            },
            step2: {
                title: 'Indica la potenza dell’impianto fotovoltaico esistente',
                nextValidationFailMessage: 'E\' necessario indicare la dimensione del Sistema Solare esistente'
            },
            step3: {
                title: 'Indica i tuoi consumi attuali di energia elettrica',
                nextValidationFailMessage: 'E\' necessario indicare i consumi attuali della tua bolletta'
            },
            step4: {
                title: 'Indica le tue abitudini di consumo',
                nextValidationFailMessage: 'E\' necessario fornire una risposta'
            }
        },
        quotations: {
            title: 'Scegli la soluzione più adatta a te'
        },
        configurationState: {
            user: {
                exclude: ['pv', 'city', 'postalCode']
            },
            configuration: {
                exclude: ['systemCoords', 'electricityConsumptionPersone', 'electricityConsumptionCost']
            }
        }
    },
    // user data
    user: {
        address: {
            label: 'Indirizzo',
            webServiceParamName: 'indirizzo'
        },
        pv: {
            label: 'Provincia'
        },
        city: {
            label: 'Città'
        },
        postalCode: {
            label: 'Codice postale'
        },
        email: {
            label: 'Email'
        }
    },
    // solar system configuration data (steps filled by the user)
    configuration: {
        roofArea: {
            label: 'Superficie',
            measureUnit: 'mq',                                                  // optional
            webServiceParamName: 'area'                                         // optional
            //webServiceValueFn:                                                // optional
            //valueProcessFn: (value) => value*value                            // optional, processes value
            //valueGuiFn: (value) => value + ' for gui'                         // optional, gets value's gui representation
            //valueGuiForConfigurationStateFn: (value) => value + ' for gui'    // optional, gets value's gui representation for ConfiguratinState Component
        },
        systemCoords: {
            label: 'Coordinate geografiche del sistema',
            webServiceValueFn: (value) => {
                return `${ value.lat },${ value.lng }`;
            }
        },
        powerFTV:  {
            label: 'Dimensione Sistema Solare esistente',
            webServiceValueFn: (value) => {
                const map = {
                    'lte3': '<=3',
                    'e4': '=4.5',
                    'e6': '=6',
                    'e10': '=10',
                    'gt10': '>10'
                }
                return map[value];
            },
            valueGuiFn: (value) => {
                const map = {
                    'lte3': '<= 3 kWp',
                    'e4': '4.5 kWp',
                    'e6': '6 kWp',
                    'e10': '10 kWp',
                    'gt10': '> 10 kWp'
                }
                return map[value];
            }
        },
        electricityConsumption: {
            label: 'Consumo di energia',
            measureUnit: 'kWh/anno',  
            webServiceParamName: 'fabbisogno',
            valueGuiFn: (value) => {
                const map = {
                    '1persona': '1 persona',
                    '2persone': '2 persone',
                    '3persone': '3 persone',
                    '4persone': '4 persone',
                    'Plus4persone': '4+ persone'
                }
                return map[value];
            },
            valueGuiForConfigurationStateFn: (value) => {
                return floatStringFormat(value.toString());
            }
        },
        houseUsage: {
            label: 'Utilizzo della casa',
            webServiceParamName: 'utilizzo',
            webServiceValueFn: (value) => {
                const map = {
                    'Vuota24': 0,
                    'Occupata24': 1,
                    'OccupataMattina': 2,
                    'OccupataPost18': 3
                }
                return map[value];
            },
            valueGuiFn: (value) => {
                const map = {
                    'Vuota24': 'Vuota tutto il giorno',
                    'Occupata24': 'Occupata tutto il giorno',
                    'OccupataMattina': 'Occupata la mattina',
                    'OccupataPost18': 'Occupata dopo le 18:00'
                }
                return map[value];
            }
        }
    },
    externalUrls: {
        sunhub: 'https://sunhub.it/'
    }
};

/**
 * Returns a configuration item
 * @param {String} itemPath
 * @param {Object} object
 * @return {Mixed}
 * 
 * @usage
 *  const item = getConfItem('configuration');
 *  const item = getConfItem('configuration.roofArea.label'); 
 */
const getConfItem = (itemPath, object = confData) => {
    return getItem(itemPath, object);
};

const getLabel = (itemPath, defaultLabel = '') => {
    return getConfItem(itemPath + '.label') || defaultLabel;
};

const getMeasureUnit = (itemPath, defaultMeasureUnit = '') => {
    return getConfItem(itemPath + '.measureUnit') || defaultMeasureUnit;
};

const getValueProcessFn = (itemPath) => {
    return getConfItem(itemPath + '.valueProcessFn');
};

const getValueGuiFn = (itemPath) => {
    return getConfItem(itemPath + '.valueGuiFn');
};

const getValueGuiForConfigurationStateFn = (itemPath) => {
    return getConfItem(itemPath + '.valueGuiForConfigurationStateFn');
};

const getWebServiceParamName = (itemPath) => {
    return getConfItem(itemPath + '.webServiceParamName');
};

const getWebServiceValueFn = (itemPath) => {
    return getConfItem(itemPath + '.webServiceValueFn');
};

const getStepTitle = (step) => {
    return getConfItem('gui.steps.step' + step + '.title');
};

const getQuotationsTitle = () => {
    return getConfItem('gui.quotations.title');
};

export default confData;
export {
    getConfItem,
    getLabel,
    getMeasureUnit,
    getValueProcessFn,
    getValueGuiFn,
    getValueGuiForConfigurationStateFn,
    getWebServiceParamName,
    getWebServiceValueFn,
    getStepTitle,
    getQuotationsTitle
};